import React from 'react';
import { motion } from 'framer-motion';
import { Star, CheckCircle2, Quote } from 'lucide-react';
const reviews = [{
  text: 'Nach 3 Wochen schlafe ich zum ersten Mal seit Jahren durch. Kein Aufstehen um 3 Uhr mehr. Meine Frau hat es zuerst bemerkt.',
  author: 'Helmut K.',
  location: 'München',
  age: '62',
  role: 'Verifizierter Käufer',
  initials: 'HK'
}, {
  text: 'Ich war skeptisch, aber die Kombination aus Sägepalme und Pygeum in dieser Dosierung ist einzigartig. Nach 6 Wochen: nur noch einmal pro Nacht, Tendenz fallend.',
  author: 'Dr. Wolfgang M.',
  location: 'Wien',
  age: '58',
  role: 'Verifizierter Käufer',
  initials: 'WM'
}, {
  text: "Endlich ein Produkt, das transparent mit Dosierungen umgeht. Keine 'proprietary blends'. Ich weiß genau, was ich nehme.",
  author: 'Thomas R.',
  location: 'Bremen',
  age: '54',
  role: 'Verifizierter Käufer',
  initials: 'TR'
}];
export function SocialProofSection() {
  return <section className="py-28 md:py-32 bg-slate-50 text-slate-900 relative overflow-hidden" data-id="element-387">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-388">
        <div className="text-center mb-20" data-id="element-389">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-brand-500 font-bold tracking-[0.2em] text-sm uppercase mb-4 block" data-id="element-390"></motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-serif font-bold text-slate-900 mb-6" data-id="element-391">
            Was unsere Kunden berichten
          </motion.h2>
          <div className="flex justify-center gap-1 text-amber-400 mb-3" data-id="element-392">
            {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-6 h-6 fill-current" data-id="element-393" />)}
          </div>
          <p className="text-slate-500 text-base" data-id="element-394">
            Basierend auf über 1.500 Bewertungen
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-395">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-10 rounded-2xl border border-slate-200 relative flex flex-col hover:border-brand-200 hover:shadow-md transition-all duration-300" data-id="element-396">
              <Quote className="absolute top-8 right-8 w-12 h-12 text-slate-100 rotate-180" data-id="element-397" />

              <div className="flex gap-1 text-amber-400 mb-6" data-id="element-398">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-current" data-id="element-399" />)}
              </div>

              <p className="text-slate-700 italic mb-8 leading-loose text-lg flex-grow relative z-10" data-id="element-400">
                "{review.text}"
              </p>

              <div className="flex items-center gap-4 mt-auto border-t border-slate-100 pt-6" data-id="element-401">
                <div className="w-12 h-12 rounded-full bg-brand-50 border border-brand-200 flex items-center justify-center text-brand-600 font-serif font-bold" data-id="element-402">
                  {review.initials}
                </div>
                <div data-id="element-403">
                  <p className="font-bold text-slate-900 text-lg" data-id="element-404">
                    {review.author}, {review.age}
                  </p>
                  <p className="text-sm text-slate-500 mb-1" data-id="element-405">
                    {review.location}
                  </p>
                  <div className="flex items-center gap-1.5" data-id="element-406">
                    <CheckCircle2 className="w-3.5 h-3.5 text-brand-500" data-id="element-407" />
                    <span className="text-xs text-brand-500 uppercase tracking-wide font-medium" data-id="element-408">
                      {review.role}
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}